import type { ReactNode } from 'react';

export type RxIconName =
  | 'search'
  | 'bell'
  | 'chevron'
  | 'shield'
  | 'doc'
  | 'scan'
  | 'user'
  | 'home'
  | 'list'
  | 'chart'
  | 'plus'
  | 'download'
  | 'arrow_up'
  | 'arrow_down'
  | 'fingerprint'
  | 'face'
  | 'lock'
  | 'mail'
  | 'filter'
  | 'check'
  | 'warn'
  | 'ledger'
  | 'more'
  | 'arrow_right_long'
  | 'back'
  | 'paperclip'
  | 'refresh'
  | 'logout'
  | 'settings'
  | 'help'
  | 'flash'
  | 'folder';

const PATHS: Record<RxIconName, ReactNode> = {
  search: (
    <path
      d="M11 4a7 7 0 105.2 11.7l3.5 3.5M11 4a7 7 0 015.2 11.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  bell: (
    <path
      d="M5 16h14l-2-2v-4a5 5 0 00-10 0v4l-2 2zm5 2a2 2 0 004 0"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  chevron: (
    <path
      d="M7 4l6 6-6 6"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  shield: (
    <path
      d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z M9 12l2 2 4-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  doc: (
    <path
      d="M6 3h8l4 4v14H6V3z M14 3v4h4 M9 12h6 M9 16h4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  scan: (
    <path
      d="M4 8V5a1 1 0 011-1h3 M20 8V5a1 1 0 00-1-1h-3 M4 16v3a1 1 0 001 1h3 M20 16v3a1 1 0 01-1 1h-3 M4 12h16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  user: (
    <path
      d="M12 12a4 4 0 100-8 4 4 0 000 8z M4 20c0-4 4-6 8-6s8 2 8 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  home: (
    <path
      d="M3 11l9-7 9 7v9a1 1 0 01-1 1h-5v-6h-6v6H4a1 1 0 01-1-1v-9z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  list: (
    <path
      d="M4 6h16 M4 12h16 M4 18h16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  chart: (
    <path
      d="M4 20h16 M7 17v-6 M12 17V7 M17 17v-9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  plus: (
    <path
      d="M12 5v14 M5 12h14"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      fill="none"
    />
  ),
  download: (
    <path
      d="M12 4v12 M7 11l5 5 5-5 M5 20h14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  arrow_up: (
    <path
      d="M12 19V5 M6 11l6-6 6 6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  arrow_down: (
    <path
      d="M12 5v14 M6 13l6 6 6-6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  fingerprint: (
    <path
      d="M8 11a4 4 0 018 0v2c0 2-.5 4-1.5 5.5 M5 14c0-3.5 3-7 7-7s7 3.5 7 7 M12 11v3c0 2-1 3-2 4 M15 18c.5-1 1-3 1-5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  face: (
    <path
      d="M7 4H5a1 1 0 00-1 1v2 M17 4h2a1 1 0 011 1v2 M7 20H5a1 1 0 01-1-1v-2 M17 20h2a1 1 0 001-1v-2 M9 10v1 M15 10v1 M9 15c1 1 2 1.5 3 1.5s2-.5 3-1.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  lock: (
    <path
      d="M6 11V8a6 6 0 0112 0v3 M5 11h14v9H5v-9z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  mail: (
    <path
      d="M4 6h16v12H4V6z M4 6l8 6 8-6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  filter: (
    <path
      d="M4 6h16 M7 12h10 M10 18h4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  check: (
    <path
      d="M5 13l4 4 10-10"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  warn: (
    <path
      d="M12 4l9 16H3l9-16z M12 10v4 M12 17v.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  ledger: (
    <path
      d="M4 4h16v16H4V4z M4 9h16 M9 4v16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  more: (
    <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="6" cy="12" r="1" fill="currentColor" />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
      <circle cx="18" cy="12" r="1" fill="currentColor" />
    </g>
  ),
  arrow_right_long: (
    <path
      d="M5 12h14 M14 7l5 5-5 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  back: (
    <path
      d="M14 6l-6 6 6 6"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  paperclip: (
    <path
      d="M16 7l-7 7a3 3 0 104.2 4.2L21 10a5 5 0 00-7-7l-7 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  refresh: (
    <path
      d="M4 12a8 8 0 0114-5l2 2 M20 12a8 8 0 01-14 5l-2-2 M16 4v3h3 M8 20v-3H5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  logout: (
    <path
      d="M15 4h4a1 1 0 011 1v14a1 1 0 01-1 1h-4 M3 12h12 M11 8l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  settings: (
    <path
      d="M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z M19.4 13.6l1.5 1-1.2 2.1-1.8-.3a7 7 0 01-2 1.2l-.3 1.8h-2.4l-.3-1.8a7 7 0 01-2-1.2l-1.8.3-1.2-2.1 1.5-1a7 7 0 010-2.3l-1.5-1 1.2-2.1 1.8.3a7 7 0 012-1.2l.3-1.8h2.4l.3 1.8a7 7 0 012 1.2l1.8-.3 1.2 2.1-1.5 1a7 7 0 010 2.3z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  help: (
    <path
      d="M12 3a9 9 0 100 18 9 9 0 000-18z M9.5 9a2.5 2.5 0 014.7 1.1c0 1.4-2.2 2-2.2 3.4 M12 17v.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  flash: (
    <path
      d="M13 3L5 14h6l-1 7 8-11h-6l1-7z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  folder: (
    <path
      d="M3 7a1 1 0 011-1h5l2 2h9a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V7z M3 10h18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
};

interface IconProps {
  name: RxIconName;
  size?: number;
  color?: string;
  className?: string;
}

export function Icon({ name, size = 20, color, className }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={{ display: 'block', color: color ?? 'currentColor', flexShrink: 0 }}
      role="img"
      aria-label={name}
    >
      <title>{name}</title>
      {PATHS[name]}
    </svg>
  );
}
